import React from 'react';
import profileImg from '../../profile.jpg';

const About = ({ language }) => {
  const translations = {
    de: {
      about_title: "Über mich",
      quote: "„Neugier ist mein Antrieb – Systeme von Grund auf verstehen, hinterfragen und nachhaltig verbessern.“",
      about_p1: "Willkommen auf meiner Website! Ich bin <b>Elias</b> – <b>technologiebegeistert</b>, <b>analytisch denkend</b> und angetrieben von dem Wunsch, komplexe Systeme im Kern zu verstehen. Schon früh hat mich die Informatik fasziniert: Mich begeistert nicht nur, <i>dass</i> etwas funktioniert, sondern vor allem das <b>Warum</b> – die Architektur, die Logik und die unsichtbaren Mechanismen im Hintergrund.",
      about_p2: "Technologie bedeutet für mich weit mehr als reiner Code: Es ist eine Denkweise. Ich liebe es, <b>komplexe Probleme methodisch zu zerlegen</b>, <b>kreative Lösungen zu entwickeln</b> und mich kontinuierlich neuen Herausforderungen zu stellen – sei es in der Softwareentwicklung, im IT-Alltag oder im direkten Austausch mit motivierten Teams.",
      about_p3: "Abseits der Technik lege ich großen Wert auf einen gesunden <b>Ausgleich im Alltag</b>: Ich halte mich regelmäßig mit <b>Sport fit</b>, interessiere mich für neue Technologien und genieße das Leben in Wien mit einer guten Portion Neugier und Begeisterung.",
      tags: ["Analytisch & Zielstrebig", "Lebenslanges Lernen", "Kreativer Problemlöser", "Ausgeglichen & Aktiv"],
      role_label: "Job Titel",
      role_value: "Junior Penetration Tester",
      company_label: "Unternehmen",
      company_value: "TÜV Trust IT",
      education_label: "Ausbildung",
      education_value: "MSc IT Security"
    },
    en: {
      about_title: "About Me",
      quote: "“Curiosity is my driver—understanding systems from the ground up, challenging them, and building them better.”",
      about_p1: "Welcome to my website! I'm <b>Elias</b>—a <b>tech enthusiast</b>, <b>analytical thinker</b>, and problem-solver driven by a deep desire to understand how systems work at their core. From an early age, computing captured my curiosity: I was never content just knowing <i>that</i> something works, but fascinated by the <b>why</b>—the underlying architecture, logic, and invisible mechanisms.",
      about_p2: "To me, technology is far more than just code: it is a mindset. I thrive on <b>breaking down complex challenges</b>, <b>crafting creative solutions</b>, and constantly pushing my boundaries—whether in modern software engineering, daily IT challenges, or collaborating with passionate teams.",
      about_p3: "Outside the digital realm, maintaining a healthy <b>balance in life</b> is essential to me: I stay active with <b>regular workouts and sports</b>, explore emerging technologies, and embrace life in Vienna with open-minded curiosity.",
      tags: ["Analytical & Driven", "Lifelong Learner", "Creative Problem Solver", "Active & Balanced"],
      role_label: "Job Title",
      role_value: "Junior Penetration Tester",
      company_label: "Company",
      company_value: "TÜV Trust IT",
      education_label: "Education",
      education_value: "MSc IT Security"
    }
  };

  const t = translations[language];

  return (
    <>
      <h2>{t.about_title}</h2>

      <div className="about-grid">
        <div className="about-left">
          <div className="profile-image-container">
            <img src={profileImg} alt="Profile" className="profile-img" />
          </div>

          <div className="info-cards">
            <div className="info-card">
              <span className="card-label">{t.role_label}</span>
              <span className="card-value">{t.role_value}</span>
            </div>
            <div className="info-card">
              <span className="card-label">{t.company_label}</span>
              <span className="card-value">{t.company_value}</span>
            </div>
            <div className="info-card">
              <span className="card-label">{t.education_label}</span>
              <span className="card-value">{t.education_value}</span>
            </div>
          </div>
        </div>

        <div className="about-right">
          <div className="about-text-card">
            <div className="about-quote-box">
              <p className="about-quote">{t.quote}</p>
            </div>
            <div className="about-paragraphs">
              <p dangerouslySetInnerHTML={{ __html: t.about_p1 }} />
              <p dangerouslySetInnerHTML={{ __html: t.about_p2 }} />
              <p dangerouslySetInnerHTML={{ __html: t.about_p3 }} />
            </div>
            <div className="about-tags">
              {t.tags.map((tag, idx) => (
                <span key={idx} className="about-tag-badge">{tag}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;